import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IContainer, IContainerState } from "./containerModel";
import {
  ContainerActiveInactive,
  createContainer,
  deleteContainer,
  getAllActiveContainer,
  getAllContainer,
  getContainerByID,
  updateContainer,
} from "./services/container.service";

const initialState: IContainerState = {
  loading: false,
  formLoading: false,
  error: "",
  ContainerList: [],
  ContainerID: null,
  ContainerDetail: {
    container_type: "",
    isactive: 1,
  },
};

const containerSlice = createSlice({
  name: "container",
  initialState,
  reducers: {
    clearContainerDetails: (state) => {
      state.ContainerDetail = initialState.ContainerDetail;
    },
    setContainerID: (state, action) => {
      state.ContainerID = action.payload;
    },
    clearContainerID: (state) => {
      state.ContainerID = initialState.ContainerID;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllContainer.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllContainer.fulfilled,
      (state, action: PayloadAction<IContainer[]>) => {
        state.loading = false;
        state.ContainerList = action.payload || [];
      }
    );
    builder.addCase(getAllContainer.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.ContainerList = [];
    });
    builder.addCase(getAllActiveContainer.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllActiveContainer.fulfilled,
      (state, action: PayloadAction<IContainer[]>) => {
        state.loading = false;
        state.ContainerList = action.payload || [];
      }
    );
    builder.addCase(getAllActiveContainer.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.ContainerList = [];
    });
    builder.addCase(createContainer.pending, (state) => {
      state.formLoading = false;
      state.error = "";
    });
    builder.addCase(createContainer.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(createContainer.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(updateContainer.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(updateContainer.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(updateContainer.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(deleteContainer.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteContainer.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteContainer.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(ContainerActiveInactive.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(ContainerActiveInactive.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(ContainerActiveInactive.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getContainerByID.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(getContainerByID.fulfilled, (state, action: any) => {
      state.formLoading = false;
      state.ContainerDetail = action.payload;
    });
    builder.addCase(getContainerByID.rejected, (state, action) => {
      state.formLoading = false;
      state.ContainerDetail = initialState.ContainerDetail;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const { clearContainerDetails, setContainerID, clearContainerID } =
  containerSlice.actions;
export default containerSlice.reducer;
